import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormLauncher from '../../../../cmn/docAutomation/FormLauncher';
import useViewSwitcher from '../../../../../library/hooks/switch/useViewSwitcher'
import SarasViewSwitch from '../../../../../library/hooks/switch/SarasViewSwitch';
import FormDialog from '../../../../../library/form/components/FormDialog';
import SarasTrans from "../../../../../library/notifications/SarasTrans";
import prodViewMap from '../../Index'
import { UiForm } from "../../../../../library/layout/Index";

const ProdTaskIssue = (props) => {
    const { viewMap, formObject, viewData, viewSwitcher, ...restProps } = props;
    const rmViewSwitcher = useViewSwitcher("ISMA");

    //console.log("form api request ProdTaskIssue", viewData);

    // const issueGroups = [
    //     { key: "ISMA", val: "Material", isDefault: 1 },
    //     { key: "ISSF", val: "Semi Finished" }
    // ]

    if(!viewData)
        return(null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ 
                actionMessage: "PleaseWait",
                formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" }, 
                actionParam: {actionType:"issueMaterial", pathKey:"TISS"} }}
            formStyle={{ width: '900px', height: '650px' }} contentStyle={{ height: '450px' }}
            formTitle={<SarasTrans value='Issue Material' />}
            >
            <UiForm formName="issueHeader">
                <FormLauncher viewMap={prodViewMap} viewSwitcher={viewSwitcher} compositionKey="issueHeader" viewData={viewData} {...restProps}></FormLauncher>
            </UiForm>
            {/* <SarasTabsSwitch viewSwitcher={rmViewSwitcher} switches={issueGroups} kscStartAt={1} /> */}
            <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='ISMA' hideMode='soft' >
                <UiForm formName="issueMaterial">
                    <FormLauncher viewMap={prodViewMap} viewSwitcher={viewSwitcher} compositionKey="issueMaterial" viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch>
            {/* <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='ISSF' hideMode='soft' >
                <UiForm formName="issueSemiFinish">
                    <FormLauncher viewMap={prodViewMap} viewSwitcher={viewSwitcher} compositionKey="issueSemiFinish" viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch> */}
            <UiForm formName="issueAudit">
                <FormLauncher viewMap={prodViewMap} viewSwitcher={viewSwitcher} compositionKey="issueAudit" viewData={viewData} {...restProps}></FormLauncher>
            </UiForm>
        </FormDialog>
    )
}

export default withView(ProdTaskIssue, "prodTaskIssue", "prodTask,prodTaskList");